import { useNavigate } from 'react-router-dom'
import { Plus, ExternalLink } from 'lucide-react'

export function NoActiveProject() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="bg-white rounded-lg shadow-lg p-16 max-w-2xl w-full">
        <div className="flex flex-col items-center justify-center text-center">
          {/* Icon */}
          <div className="mb-6">
            <svg
              className="mx-auto h-20 w-20 text-gray-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          {/* Message */}
          <h2 className="text-3xl font-bold text-gray-900 mb-2">No Active Project</h2>
          <p className="text-gray-500 mb-8 text-base">
            You don't have any active projects assigned yet.
          </p>

          {/* Action Buttons */}
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={() => navigate('/projects')}
              className="px-8 py-3 rounded-lg font-semibold transition duration-200 flex items-center gap-2 whitespace-nowrap"
              style={{
                backgroundColor: '#358ECD',
                color: 'white',
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2a6fa3'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#358ECD'}
            >
              <Plus className="w-5 h-5" />
              Create New Project
            </button>
            <button
              onClick={() => navigate('/projects')}
              className="px-8 py-3 rounded-lg font-semibold transition duration-200 border-2 flex items-center gap-2 whitespace-nowrap"
              style={{
                borderColor: '#358ECD',
                color: '#358ECD',
                backgroundColor: 'white',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f0f7ff'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'white'
              }}
            >
              <ExternalLink className="w-5 h-5" />
              View All Projects
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
